import { render, staticRenderFns } from "./CbsPagination.vue?vue&type=template&id=690bad14&scoped=true"
import script from "./CbsPagination.vue?vue&type=script&lang=js"
export * from "./CbsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690bad14",
  null
  
)

export default component.exports